import { render, staticRenderFns } from "./SiteCompletion.vue?vue&type=template&id=5a20cb1a"
import script from "./SiteCompletion.vue?vue&type=script&lang=js"
export * from "./SiteCompletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports